const baseURL = 'www.baidu.com'
const token = '123456'
const userSite = '林花落了春红，太匆匆'

export default {
  baseURL,
  token,
  userSite,
  
}


// WEBPACK FOOTER //
// ./src/assets/globalVariable.js